module.exports = __webpack_public_path__ + "img/SPACE.d23e6cfb.png";